import React from 'react';
import Logo from './Logo';
import AdminPanel from './Admin/AdminPanel';
import ShareButton from './ShareButton';

const Footer: React.FC = () => {
  const [isAdminOpen, setIsAdminOpen] = React.useState(false);

  return (
    <>
      <footer className="bg-[#132947] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
          <Logo size="medium" />
          
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-center">
            <a href="#about" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">About</a>
            <a href="#mission" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Mission</a>
            <a href="/rateyouroast" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Rate Your Roast</a>
            <a href="/coffee" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">The Coffee Project</a>
            <a href="/bonus-batch" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Bonus Batch</a>
            <a href="/coffee-lab" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Coffee Lab</a>
            <a href="/mff-impact" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Coffee & Community</a>
            <a href="/custom-branding" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Custom Branding</a>
            <ShareButton variant="minimal" size="small" />
            <a 
              href="https://www.instagram.com/thebondcoffee/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#fda36b] transition-colors whitespace-nowrap"
            >
              Unless you're looking for our Finsta
            </a>
              <button 
                onClick={() => setIsAdminOpen(true)}
                className="hover:text-[#fda36b] transition-colors whitespace-nowrap"
              >
                Admin
              </button>
            <a href="#signup" className="hover:text-[#fda36b] transition-colors whitespace-nowrap">Shop</a>
          </div>
        </div>
        
        <div className="mt-12 text-center text-sm text-gray-400 space-y-4">
          <p className="text-white/80">
            Questions? Reach us at{' '}
            <a 
              href="mailto:hello@thebondcoffee.com" 
              className="text-[#fda36b] hover:text-[#fda36b]/80 transition-colors underline"
            >
              hello@thebondcoffee.com
            </a>
          </p>
          <p className="text-white/60 leading-relaxed px-4">
            We don't do social media. Instead, follow{' '}
            <a 
              href="https://open.spotify.com/artist/10gxv0M3KdupahLvL53Rs7?si=np0ATTVIQR2Jlv86GLRIaw" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#fda36b] hover:text-[#fda36b]/80 transition-colors underline"
            >
              Adam's high school band on Spotify
            </a>
            . Unless you're looking for{' '}
            <a 
              href="https://www.instagram.com/thebondcoffee/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#fda36b] hover:text-[#fda36b]/80 transition-colors underline"
            >
              our Finsta
            </a>
            .
          </p>
          <p className="pt-2">© 2024 Bond Coffee Roasters. All rights reserved.</p>
        </div>
      </div>
      </footer>
      
      <AdminPanel isOpen={isAdminOpen} onClose={() => setIsAdminOpen(false)} />
    </>
  );
};

export default Footer;